import { AddedEntity } from '../api-results/base.api-result';
import {
  AddEcosDebriefPictureResult,
  EcosDebriefPictureResult,
  EcosDebriefResult,
  EcosDebriefVideoResult,
} from '../api-results/ecos-debrief.api-result';
import {
  AddEcosDebriefVideoPayload,
  EcosDebriefFormValue,
  UpdateEcosDebriefPayload,
} from '../payloads/ecos-debrief.payload';

export class EcosDebrief {
  debriefing: string;
  debriefingPictures: EcosDebriefPicture[];
  debriefingVideos: EcosDebriefVideo[];

  constructor(result: EcosDebriefResult) {
    this.debriefing = result.debriefing;
    if (result.debriefingPictures)
      this.debriefingPictures = result.debriefingPictures.map((elt) => new EcosDebriefPicture(elt));
    if (result.debriefingVideos)
      this.debriefingVideos = result.debriefingVideos.map((elt) => new EcosDebriefVideo(elt));
  }

  static updatedEntityToResult(payload: UpdateEcosDebriefPayload): Partial<EcosDebriefResult> {
    return {
      debriefing: payload.debriefing,
    };
  }

  toFormValue(): Partial<EcosDebriefFormValue> {
    return {
      debriefing: this.debriefing,
    };
  }
}

export class EcosDebriefPicture {
  id: string;
  picture: string;

  constructor(result: EcosDebriefPictureResult) {
    this.id = result.id;
    this.picture = result.picture;
  }

  static addedEntityToResult(addedEntity: AddEcosDebriefPictureResult): EcosDebriefPictureResult {
    return {
      id: addedEntity.id,
      picture: addedEntity.picture,
    };
  }
}

export class EcosDebriefVideo {
  id: string;
  video: string;

  constructor(result: EcosDebriefVideoResult) {
    this.id = result.id;
    if (result.video)
      this.video = result.video.replace(/style="(.*?)"/, '').replace(/style="(.*?)"/, '');
  }

  static addedEntityToResult(
    payload: AddEcosDebriefVideoPayload,
    addedEntity: AddedEntity
  ): EcosDebriefVideoResult {
    return {
      id: addedEntity.id,
      video: payload.video,
    };
  }
}
